var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./clojure.test.check.generators.js");require("./clojure.test.check.results.js");
'use strict';